<template>
	<label
		class="checkbox prevent-highlight-mobile"
		:class="{ disabled, 'checkbox--rectangle': type === 'rectangle' }"
	>
		<input
			:id="id"
			:disabled="disabled"
			:checked="checked"
			type="checkbox"
			@change="change"
		/>
		<label class="check" :class="{ disabled }" :for="id" />
		<label v-if="label" :for="id" class="checkbox-label" :class="{ disabled }">
			{{ label }}
		</label>
		<slot />
	</label>
</template>

<script>
export default {
	name: 'CustomCheckBox',

	props: {
		checked: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		id: {
			type: [String, Number],
			required: true
		},
		label: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: 'square',
			validator: value => {
				return ['square', 'rectangle'].includes(value)
			}
		}
	},

	methods: {
		change(e) {
			this.$emit('change', e.target.checked)
		}
	}
}
</script>

<style lang="scss">
@import './src/assets/styles/variables';

.checkbox {
	display: inline-block;
	vertical-align: top;
	position: relative;
	overflow: hidden;

	input {
		position: absolute;
		left: -9999px;
	}

	&:not(.checkbox--rectangle) {
		&.inversion {
			.check {
				border-color: $border-color;

				&:after {
					display: block;
				}
			}

			.checkbox-label {
				color: #816cc2;
			}

			input:checked {
				.check {
					border-color: $border-color;

					&:after {
						display: none;
					}
				}
			}
		}

		&.disabled {
			opacity: 0.5;
			pointer-events: none;
			cursor: default;

			.disabled {
				opacity: 1;
				cursor: default;
			}
		}

		input {
			&:checked {
				& ~ .check {
					border-color: $border-color;

					&:after {
						display: block;
					}
				}

				& ~ .checkbox-label {
					color: #fff;
				}
			}
		}

		label {
			cursor: pointer;
		}

		.check {
			float: left;
			width: 24px;
			height: 24px;
			margin: 0 16px 0 0;
			border: 1px solid $border-color;
			border-radius: 5px;
			position: relative;

			&:after {
				position: absolute;
				left: 3px;
				top: 5px;
				width: 14px;
				height: 5px;
				border: solid $border-color;
				border-width: 0 0 2px 2px;
				transform: rotate(-45deg);
				content: '';
				display: none;
			}
		}

		&.error {
			color: #e9576a;

			.check {
				border-color: #e9576a;
			}
		}
	}

	&--rectangle {
		width: 100%;

		.check {
			display: none;
		}

		input {
			&:checked {
				& ~ .radio-label {
					border-color: $pink;
					background-color: $background-box;
				}
			}
		}

		.radio-label {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			background-color: $background-box;
			min-height: 54px;
			border: 1px solid $border-color;
			border-radius: 12px;
			padding: 15px 16px;
			font-size: 16px;
			transition: background-color 0.5s;
			cursor: pointer;

			@media (min-width: 1024px) {
				&:hover {
					background-color: rgba($light-blue, 0.25);
				}
			}
		}

		&.error {
			color: #e9576a;
		}

		&.disabled {
			opacity: 0.5;
			pointer-events: none;
			cursor: default;

			.disabled {
				opacity: 1;
				cursor: default;
			}
		}
	}
}

.checkbox-label {
	display: block;
	overflow: hidden;
}
</style>
